let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i0Evx")).then(() => parcelRequire('84bj3'));